export const initial = {
    nav: null,
    promoted: null,
    hexagram: null,
};

export function nav(state, payload) {
    return { ...state, nav: { ...state.nav, [payload.tag]: payload.data } };
}

export function promoted(state, payload) {
    return { ...state, promoted: payload };
}

export function hexagram(state, payload) {
    return { ...state, hexagram: payload };
}



// WEBPACK FOOTER //
// ./app/reducers/content.js